module.exports = __webpack_public_path__ + "static/Toli-CV_WordCloud-NEW-37c25f86403d4276c97d4bf060fdc289.jpg";